import PasswordValidator from 'password-validator';

const nicknameSchema = new PasswordValidator().is().min(3).is().max(15).has().not().spaces();

const nameSchema = new PasswordValidator()
  .is()
  .min(2)
  .is()
  .max(20)
  .has()
  .not()
  .digits()
  .has()
  .uppercase();

const passwordSchema = new PasswordValidator()
  .is()
  .min(6)
  .is()
  .max(20)
  .has()
  .uppercase()
  .has()
  .lowercase()
  .has()
  .digits()
  .has()
  .not()
  .spaces();

export const validateEmail = (email) =>
  !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    email,
  )
    ? 'Enter a valid email address'
    : '';

export const validateNickname = (nickname) => {
  const nicknameValidation = nicknameSchema.validate(nickname, { list: true });

  return nicknameValidation
    .map((validationError) => {
      switch (validationError) {
        case 'min':
          return 'Must be at least 3 characters long';
        case 'max':
          return 'Must be max 15 characters long';
        case 'spaces':
          return 'Must not contain spaces';
        default:
          return '';
      }
    })
    .join('\n');
};

export const validateName = (name) => {
  const validationResult = nameSchema.validate(name, { list: true });

  return validationResult
    .map((validationError) => {
      switch (validationError) {
        case 'min':
          return 'Must be at least 2 characters long';
        case 'max':
          return 'Must be max 20 characters long';
        case 'digits':
          return 'Must not contain digits';
        case 'uppercase':
          return 'Must start with an uppercase letter';
        default:
          return '';
      }
    })
    .join('\n');
};

export const validatePassword = (password, passwordRepeat) => {
  const passwordValidation = passwordSchema.validate(password, { list: true });

  return [
    ...(passwordRepeat !== password ? ['Repeat passord must match password'] : []),
    ...passwordValidation.map((validationError) => {
      switch (validationError) {
        case 'min':
          return 'Must be at least 6 characters long';
        case 'max':
          return 'Must be max 20 characters long';
        case 'digits':
          return 'Must contain at least one digit';
        case 'uppercase':
          return 'Must contain at least one uppercase character';
        case 'lowercase':
          return 'Must contain at least one lowercase character';
        case 'spaces':
          return 'Must not contain spaces';
        default:
          return '';
      }
    }),
  ].join('\n');
};

export const validateCheckbox = (isChecked) =>
  !isChecked ? 'You must accept the Data Policy' : '';
